import React from 'react';

const GroupTitle = ({title}) => (
    <div className='row'>
        <div className='col-sm-12'>
            <div className='group-title'>
                {title}
            </div>
        </div>
    </div>
);

export default GroupTitle;



// WEBPACK FOOTER //
// ./src/components/Calculator/GroupTitle.js